import React from 'react';
import ResetPasswordForm from '../../components/auth/ResetPasswordForm/ResetPasswordForm';

function ResetPassword() {
  return (
    <div className="d-flex a-center j-center full-view-height mobile-a-stretch">
      <ResetPasswordForm />
    </div>
  );
}

export default ResetPassword;
